/* eslint-disable no-unused-vars */
import { memo } from 'react';
import { ConversionTracking } from 'components';
import { changeLink_inAllId, update_tc_numberInAllId } from 'utils';

const conversionTrackingPages = {
  edit: (props) => <ConversionTracking.EditCampaign {...props} />,
  new_empty: (props) => <ConversionTracking.NewCampaign_empty {...props} />,
  duplicate: (props) => <ConversionTracking.EditCampaign {...props} />,
};

const DeteilsComponet = ({ environment, data, expanded }) => {
  const ComponentToRender = conversionTrackingPages[environment];

  return (
    <>
      {ComponentToRender({
        ...data?.[0],
        isFetch: expanded === 'creatives' || expanded === 'conversionTracking',
        linkUpdateAction: changeLink_inAllId,
        update_tc_number: update_tc_numberInAllId,
      })}
    </>
  );
};

export default memo(DeteilsComponet);
